/**
 * Operations API Service
 * 
 * API calls for admin operations dashboard.
 */

import { apiClient } from "./apiClient";

export interface OperationsDashboardResponse {
  executions_today: {
    success: number;
    failed: number;
    pending: number;
    total: number;
  };
  top_errors: Array<{
    error: string;
    count: number;
  }>;
  payments: {
    pending: number;
    rejected: number;
  };
  subscriptions: {
    expiring_soon: number;
  };
  timestamp: string;
}

/**
 * Get operations dashboard data
 */
export async function getOperationsDashboard(): Promise<OperationsDashboardResponse> {
  const response = await apiClient.get<OperationsDashboardResponse>(
    "/admin/operations/dashboard",
  );
  return response.data;
}

